export const handleApiError = (error) => {
  // Check if it's an Axios error or a standard error
  const message =
    error.response?.data?.message ||
    error.message ||
    "An unexpected error occurred";

  // 1. Log to console for debugging (Red color)
  console.error("API Error:", message);

  // 2. Optional: You could trigger a Toast/Alert notification here
  // toast.error(message);

  return message;
};
